// SPのヘッダーメニューボタン
export class HeaderMemu {
  constructor() {
    this.DOM = {};
    this.DOM.menuButton = document.querySelector('[data-menu-trigger]');
    this.DOM.menuContent = document.querySelector('[data-menu-target]');
    // メニューコンテンツ内のリンクを全取得
    this.DOM.menuLinks = this.DOM.menuContent ? this.DOM.menuContent.querySelectorAll('a') : [];
    this.ACTIVE_CLASS = 'is-showed'; // is-openedはAccordionと競合

    if (!this.DOM.menuButton) return;

    new HeaderPulldown();
    this.init();
  }

  init() {
    // ヘッダーメニューボタンのクリックイベント
    this.DOM.menuButton.addEventListener('click', () => {
      if( !this.isMenuOpend() ) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });

    this.DOM.menuContent.addEventListener('click', (event) => {
      if (event.target === event.currentTarget) {
        // 親要素のときのみ実行
        if( !this.isMenuOpend() ) {
          this.openMenu();
        } else {
          this.closeMenu();
        }
      }
    });

    // 「同じページのアンカーリンク」の場合はメニューを閉じる 
    this.DOM.menuLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (this.isCurrentPageAnchor(link)) {
          this.closeMenu();
        }
      });
    });
  }
// 💡 クリックされたリンクが「現在のページ内のアンカー」か判定する関数
  isCurrentPageAnchor(link) {
    const linkUrl = new URL(link.href, window.location.href);

    // 1. ハッシュ（#）が存在しない場合は、ただの下層遷移リンクなので対象外
    if (!linkUrl.hash) return false;

    // 2. ホスト名（ドメイン）とパス名（/about/など）が、現在のページと一致するか確認
    const isSameHost = linkUrl.host === window.location.host;
    const isSamePath = linkUrl.pathname === window.location.pathname;

    return isSameHost && isSamePath;
  }

  isMenuOpend() {
    return this.DOM.menuButton.classList.contains(this.ACTIVE_CLASS);
  }

  openMenu() {
    this.DOM.menuButton.classList.add(this.ACTIVE_CLASS);
    this.DOM.menuContent.classList.add(this.ACTIVE_CLASS);
    this.fixBody(); 
  }

  closeMenu(){
    this.DOM.menuButton.classList.remove(this.ACTIVE_CLASS);
    this.DOM.menuContent.classList.remove(this.ACTIVE_CLASS);
    this.unfixBody();
  }

  // 背景スクロールを防止する処理
  fixBody() {
    // iOS等でのスクロールバグを防ぎ、完全に固定する最も手軽なCSS制御
    document.body.style.overflow = 'hidden';
  }

  // 背景スクロール制限を解除する処理
  unfixBody() {
    document.body.style.removeProperty('overflow');
  }
}

export class HeaderPulldown {
  constructor() {
    // すべてのプルダウン親要素を取得
    this.DOM = {
      pulldowns: document.querySelectorAll('[data-header-pulldown]')
    };

    this.CLASS = {
      IS_OPEN: 'is-open' // 開いている状態のクラス名
    };

    if (this.DOM.pulldowns.length === 0) return;

    this.init();
  }

  init() {
    this.bindEvents();
    this.bindOutsideClick();
  }

  /**
   * イベントの登録
   */
  bindEvents() {
    this.DOM.pulldowns.forEach((pulldown) => {
      const trigger = pulldown.querySelector('[data-header-pulldown-trigger]');
      const target = pulldown.querySelector('[data-header-pulldown-target]');

      if (!trigger || !target) return;

      // 初期状態のアリア属性を設定
      trigger.setAttribute('aria-expanded', 'false');
      target.setAttribute('aria-hidden', 'true');

      // ボタンクリックイベント
      trigger.addEventListener('click', (e) => {
        e.stopPropagation(); // 親要素へのイベント伝播を防止

        const isOpen = pulldown.classList.contains(this.CLASS.IS_OPEN);

        if (isOpen) {
          // すでに開いている場合は閉じる
          this.close(pulldown);
        } else {
          // 他のプルダウンをすべて閉じてから自身を開く（排他制御）
          this.closeAll();
          this.open(pulldown);
        }
      });
    });
  }

  /**
   * メニューを開く処理
   */
  open(pulldown) {
    const trigger = pulldown.querySelector('[data-header-pulldown-trigger]');
    const target = pulldown.querySelector('[data-header-pulldown-target]');

    pulldown.classList.add(this.CLASS.IS_OPEN);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (target) target.setAttribute('aria-hidden', 'false');
  }

  /**
   * 特定のメニューを閉じる処理
   */
  close(pulldown) {
    const trigger = pulldown.querySelector('[data-header-pulldown-trigger]');
    const target = pulldown.querySelector('[data-header-pulldown-target]');

    pulldown.classList.remove(this.CLASS.IS_OPEN);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (target) target.setAttribute('aria-hidden', 'true');
  }

  /**
   * すべてのプルダウンを閉じる処理（排他処理・メニュー外クリック用）
   */
  closeAll() {
    this.DOM.pulldowns.forEach((pulldown) => {
      this.close(pulldown);
    });
  }

  /**
   * メニュー外クリックおよびEscキーで閉じる処理
   */
  bindOutsideClick() {
    // 画面のどこかがクリックされたら全消去
    document.addEventListener('click', (e) => {
      // プルダウンエリア内のクリックでなければ閉じる
      if (!e.target.closest('[data-header-pulldown]')) {
        this.closeAll();
      }
    });

    // Escキーが押されたら閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAll();
      }
    });
  }
}
